module.exports = __webpack_public_path__ + "img/img7.4c57a7c2.jpg";